import { ExternalSource } from 'src/actions/integrations/integrationSources';
import { ExternalSourceTypes } from 'src/actions/integrations/commonTypes';

export default function (externalSources: Array<ExternalSource>): boolean {
  for (let i = 0; i < externalSources.length; i++) {
    const externalSource = externalSources[i];
    switch (externalSource.type) {
      case ExternalSourceTypes.Shopify:
      case ExternalSourceTypes.BigCommerce:
      case ExternalSourceTypes.Magento:
      case ExternalSourceTypes.Custom:
        if (externalSource.enabled) {
          return true;
        }
    }
  }
  return false;
}
